<template>
	<div class="vue-editor-container">
		<vue-editor
			id="editor"
			v-model="editorData"
			:editorOptions="editorSettings"
			:editor-toolbar="editorToolbar"
			@ready="initHandlers"
		>
		</vue-editor>
	</div>
</template>

<script>

import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
import {Quill} from "vue2-editor";
Quill.register(Quill.import('attributors/style/align'), true);


export default {
	name: "TextEditor",
	props: {
		value: {
			type: String,
			default: ''
		}
	},
	components: { VueEditor },
	data() {
		return {
			editorToolbar:[
				[
					'code', 'indent',
					{'header': [1, 2, 3, 4, 5, 6, false] },
					{ align: [] },
					{ 'font': [] },
					{ 'size': [] },
					{ 'color': [] },
					{ 'background': [] },
					'bold',
					'italic',
					'underline',
					'strike',
					'link',
					'blockquote',
					{ 'list': 'ordered'},
					{ 'list': 'bullet' },
					'clean'
				]
			],
			editorSettings: {
				history: {delay: 500, maxStack: 500, userOnly: true}
			}
		};
	},
	methods: {
		// onReady(editor) {
		// 	editor.ui.getEditableElement().parentElement.insertBefore(
		// 		editor.ui.view.toolbar.element,
		// 		editor.ui.getEditableElement()
		// 	);
		// }
		initHandlers(quill) {
			var toolbar = quill.getModule("toolbar");
			toolbar.addHandler("code", function () {
				quill.history.undo()
			});
			toolbar.addHandler("indent", function () {
				quill.history.redo()
			});

			console.log(quill);
		},
	},
	computed: {
		editorData: {
			get() {
				let currentValue = this.value.replace(/<br \/>|<br>/gi, '\n');
				do {
					currentValue = currentValue.replace(/\s<li/gi, '<li');
				}
				while (/\s<li/g.test(currentValue))
				do {
					currentValue = currentValue.replace(/\s<\/ul>/gi, '</ul>');
				}
				while (/\s<\/ul>/g.test(currentValue))
				return currentValue;
			},
			set(value) {
				this.$emit("input", value.replaceAll('\n', '<br />'))
			}
		}
	},
}
</script>


<style lang="css">
.vue-editor-container {
	max-width: 100%;
}
#editor {
	height: 240px;
}
.ql-snow .ql-picker.ql-size {
	width: 80px !important;
}
h1 {
	font-size: 2em;
	color: #000;
}

s {
	text-decoration: line-through;
}

.ql-code:after {
	content: "⬅";
}
.ql-code svg {
	display: none;
}
.ql-indent:after {
	content: "➡";
}

.ql-code:after, .ql-indent:after {
	font-size: 17px;
}

@import "~vue2-editor/dist/vue2-editor.css";

/* Import the Quill styles you want */
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';
</style>
